module.exports = __webpack_public_path__ + "static/media/Graphik-Semibold.7530481a.woff";